import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { type ClipDiscussion } from '~/components/Annotations/shared/types';
import { useAnnotationV2Context } from '~/components/AnnotationsV2/providers/AnnotationV2Provider';
import { hasAnnotation } from '~/components/AnnotationsV2/shared/annotationUtils';
import { QueryParamNames } from '~/constants/search';
import { activeDiscussionIdParamSelector } from '~/store/router/selectors';
import { setQueryParams } from '~/utils/PathUtils';

export const NEW_DISCUSSION_ID = 'newDiscussionId';

/**
 * Observer that updates activeDiscussion in context based on URL param
 */
export const useActiveDiscussionIdObserver = (discussions: ClipDiscussion[]): void => {
  const activeDiscussionId = useSelector(activeDiscussionIdParamSelector);
  const { setActiveDiscussion } = useAnnotationV2Context();

  useEffect(() => {
    if (activeDiscussionId === NEW_DISCUSSION_ID) {
      return;
    }

    if (activeDiscussionId) {
      // Look for discussion with annotations array
      const discussion = discussions.find((d) => {
        return d.id === activeDiscussionId && hasAnnotation(d);
      });

      if (discussion) {
        // Update context
        setActiveDiscussion(discussion);
      } else {
        // Discussion not found or has no annotations
        setQueryParams({ [QueryParamNames.discussionId]: null }, 'replace');
        setActiveDiscussion(null);
      }
    } else {
      // No active discussion
      setActiveDiscussion(null);
    }
  }, [activeDiscussionId, discussions, setActiveDiscussion]);
};
